import CommonQuantityInput from '../CommonQuantityInput';
import ExactQuantityDropdown from '../ExactQuantityDropdown';
import LockedQuantityDropdown from '../LockedQuantityDropdown';
import PropTypes from 'prop-types';
import { QuantityType } from '../../../../bom/constants';
import React from 'react';
import { getQuantityConfig } from '../../../../bom/selectors';
import { useSelector } from 'react-redux';

const SeparateQuantity = ({ feedback, resetFeedback }) => {
  const config = useSelector(getQuantityConfig);

  return config.type === QuantityType.Common ? (
    <CommonQuantityInput feedback={feedback} resetFeedback={resetFeedback} />
  ) : config.type === QuantityType.Exact ? (
    <ExactQuantityDropdown feedback={feedback} resetFeedback={resetFeedback} />
  ) : (
    <LockedQuantityDropdown feedback={feedback} resetFeedback={resetFeedback} />
  );
};

SeparateQuantity.propTypes = {
  feedback: PropTypes.objectOf(PropTypes.string).isRequired,
  resetFeedback: PropTypes.func.isRequired,
};

export default SeparateQuantity;
